/**
 * Generated by orval v8.18.0 🍺
 * Do not edit manually.
 * LiftAI API
 * LiftAI elevator/lift asset-management REST API.
 * OpenAPI spec version: 1.0.0 (v1)
 */
import type {
  OEMRequest,
  Oem,
  OemsListParams,
  PaginatedOEMList,
  PatchedOEMRequest
} from '../../model';

import { customFetch } from '../../../liftApiMutator';

export type oemsListResponse200 = {
  data: PaginatedOEMList
  status: 200
}

export type oemsListResponseSuccess = (oemsListResponse200) & {
  headers: Headers;
};
;

export type oemsListResponse = (oemsListResponseSuccess)

export const getOemsListUrl = (params?: OemsListParams,) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {

    if (value !== undefined) {
      normalizedParams.append(key, value === null ? 'null' : String(value))
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0 ? `/api/v1/oems/?${stringifiedParams}` : `/api/v1/oems/`
}

export const oemsList = async (params?: OemsListParams, options?: RequestInit): Promise<oemsListResponse> => {

  return customFetch<oemsListResponse>(getOemsListUrl(params),
  {
    ...options,
    method: 'GET'


  }
);}


export type oemsCreateResponse201 = {
  data: Oem
  status: 201
}

export type oemsCreateResponseSuccess = (oemsCreateResponse201) & {
  headers: Headers;
};
;

export type oemsCreateResponse = (oemsCreateResponseSuccess)

export const getOemsCreateUrl = () => {




  return `/api/v1/oems/`
}

export const oemsCreate = async (oEMRequest: OEMRequest, options?: RequestInit): Promise<oemsCreateResponse> => {

  return customFetch<oemsCreateResponse>(getOemsCreateUrl(),
  {
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(oEMRequest)
  }
);}


export type oemsRetrieveResponse200 = {
  data: Oem
  status: 200
}

export type oemsRetrieveResponseSuccess = (oemsRetrieveResponse200) & {
  headers: Headers;
};
;

export type oemsRetrieveResponse = (oemsRetrieveResponseSuccess)

export const getOemsRetrieveUrl = (id: string,) => {




  return `/api/v1/oems/${id}/`
}

export const oemsRetrieve = async (id: string, options?: RequestInit): Promise<oemsRetrieveResponse> => {

  return customFetch<oemsRetrieveResponse>(getOemsRetrieveUrl(id),
  {
    ...options,
    method: 'GET'


  }
);}


export type oemsUpdateResponse200 = {
  data: Oem
  status: 200
}

export type oemsUpdateResponseSuccess = (oemsUpdateResponse200) & {
  headers: Headers;
};
;

export type oemsUpdateResponse = (oemsUpdateResponseSuccess)

export const getOemsUpdateUrl = (id: string,) => {




  return `/api/v1/oems/${id}/`
}

export const oemsUpdate = async (id: string,
    oEMRequest: OEMRequest, options?: RequestInit): Promise<oemsUpdateResponse> => {

  return customFetch<oemsUpdateResponse>(getOemsUpdateUrl(id),
  {
    ...options,
    method: 'PUT',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(oEMRequest)
  }
);}


export type oemsPartialUpdateResponse200 = {
  data: Oem
  status: 200
}

export type oemsPartialUpdateResponseSuccess = (oemsPartialUpdateResponse200) & {
  headers: Headers;
};
;

export type oemsPartialUpdateResponse = (oemsPartialUpdateResponseSuccess)

export const getOemsPartialUpdateUrl = (id: string,) => {




  return `/api/v1/oems/${id}/`
}

export const oemsPartialUpdate = async (id: string,
    patchedOEMRequest?: PatchedOEMRequest, options?: RequestInit): Promise<oemsPartialUpdateResponse> => {

  return customFetch<oemsPartialUpdateResponse>(getOemsPartialUpdateUrl(id),
  {
    ...options,
    method: 'PATCH',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(patchedOEMRequest)
  }
);}


export type oemsDestroyResponse204 = {
  data: void
  status: 204
}

export type oemsDestroyResponseSuccess = (oemsDestroyResponse204) & {
  headers: Headers;
};
;

export type oemsDestroyResponse = (oemsDestroyResponseSuccess)

export const getOemsDestroyUrl = (id: string,) => {




  return `/api/v1/oems/${id}/`
}

export const oemsDestroy = async (id: string, options?: RequestInit): Promise<oemsDestroyResponse> => {

  return customFetch<oemsDestroyResponse>(getOemsDestroyUrl(id),
  {
    ...options,
    method: 'DELETE'


  }
);}


